import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import RinCostChangeContainer from '../../containers/accounting/RinCostChanges';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import { Button, Typography } from '@material-ui/core';
import AddRinCostDialog from '../../components/AddRinCostDialog';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addInputButton: {
		borderRadius: '100px',
		marginBottom: 10,
	},
});

const rinCostChangeColumns = [
	{
		sortId: 'rinCostChangeId',
		displayId: 'rinCostChangeId',
		labels: ['Change ID'],
	},

	{
		sortId: 'newValue',
		displayId: 'newValue',
		label: 'New Value',
	},
	{
		sortId: 'previousValue',
		displayId: 'previousValue',
		label: 'Previous Value',
	},

	{
		sortId: 'createdByDisplay',
		displayId: 'createdByDisplay',
		labels: ['Created By'],
	},

	{
		sortId: 'message',
		displayId: 'message',
		labels: ['Note'],
	},

	{
		sortId: 'startDate',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
];

class RinCostChanges extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'dateCreated',
			isAddDialogOpen: false,
		};
	}

	componentDidMount() {
		const { rinCostChangeSearch } = this.props;
		rinCostChangeSearch();
	}

	componentDidUpdate(prevProps) {
		const { rinCostChanges } = this.props;
		if (prevProps.rinCostChanges !== rinCostChanges) {
			this.formatRinCostChanges();
		}
	}

	formatRinCostChanges = () => {
		const { rinCostChanges, userMap } = this.props;
		const formattedRinCostChanges = [];
		rinCostChanges.forEach((rinCostChange) => {
			const { rinCostChangeId, createdByUserId, dateCreated } = rinCostChange;
			const createdByUser = userMap[createdByUserId] || { firstName: 'Missing' };

			rinCostChange.key = rinCostChangeId;
			rinCostChange.createdByDisplay = createdByUser.firstName;
			rinCostChange.dateCreatedFormatted = moment(dateCreated).format('M/D h:mm a');
			formattedRinCostChanges.push(rinCostChange);
		});
		this.setState({ formattedRinCostChanges });
	};

	handleCloseAddDialog = () => {
		this.setState({ isAddDialogOpen: false });
	};

	render() {
		const { classes, authUser, canRwRinCost } = this.props;

		if (!canRwRinCost) {
			return <div>You have invalid permissions to view this page.</div>;
		}

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const { formattedRinCostChanges, order, orderBy } = this.state;

		if (!formattedRinCostChanges) {
			return <div>Loading the RIN cost changes...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>RIN Cost Change History</span>
							</Typography>
						</Grid>

						<Grid item xs={4} style={{ textAlign: 'right' }}>
							<Button
								onClick={() => {
									this.setState({ isAddDialogOpen: true });
								}}
								variant="contained"
								color="primary"
								className={classes.addInputButton}
								disabled={!canMakeUpdates}
								style={{ marginTop: 0 }}
							>
								Update Current RIN Cost
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<EnhancedTable
							columns={rinCostChangeColumns}
							rows={formattedRinCostChanges}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>
					</Paper>
				</Grid>

				<AddRinCostDialog
					onClose={this.handleCloseAddDialog}
					onSuccess={this.props.rinCostChangeSearch}
					rinCostChangeAdd={this.props.rinCostChangeAdd}
					open={this.state.isAddDialogOpen}
					showErrors={this.props.showErrors}
				/>
			</Grid>
		);
	}
}

RinCostChanges.propTypes = {
	canRwRinCost: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	rinCostChangeSearch: PropTypes.func.isRequired,
	rinCostChangeAdd: PropTypes.func.isRequired,
	rinCostChanges: PropTypes.array,
	showErrors: PropTypes.func.isRequired,
	userMap: PropTypes.object,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles, { withTheme: true }), RinCostChangeContainer])(
	RinCostChanges
);
